// extracted by mini-css-extract-plugin
export var container = "Tel-module--container--Ux2T4";